import * as React from "react";
import { casesActions } from "configs";
import { useDispatch, useParams, useCurrentCase, generateId } from "duck";
import { useCreateAdditionalDiagnosticTestMutation, Fragments } from "requests";

export const useAdditionalTests = () => {
  const { shouldSync, diagnosticId } = useCurrentCase(medCase => ({
    shouldSync: medCase.shouldSync,
    diagnosticId: medCase.data.client.patient.diagnosticTesting._id
  }));

  const { id: caseId } = useParams();
  const [value, setValue] = React.useState<string[]>([]);
  const [createTest] = useCreateAdditionalDiagnosticTestMutation({
    ignoreResults: true
  });
  const dispatch = useDispatch();

  const createOnline = () => {
    Promise.all(
      value.map(id =>
        createTest({
          variables: { input: { test: id, diagnosticTesting: diagnosticId } }
        })
      )
    ).then(response => {
      const newTests = response
        .map(
          ({ data }) =>
            data?.createAdditionalDiagnosticTest?.additionalDiagnosticTest
        )
        .filter(Boolean) as Fragments.StoredAdditionalTests;
      dispatch(
        casesActions.updateAdditionalTests({ _id: caseId, data: newTests })
      );
    });
  };

  const createOffline = () => {
    const tests: Fragments.StoredAdditionalTests = value.map(test => ({
      test,
      fakeId: generateId(),
      toPerform: false
    }));
    dispatch(casesActions.updateAdditionalTests({ _id: caseId, data: tests }));
  };

  const onSave = () => {
    if (shouldSync) {
      createOnline();
    } else {
      createOffline();
    }
  };

  return { value, onChange: setValue, onSave };
};
